import React from 'react'
import styles from './BulkPost.pcss'
import { DebouncedTextField } from 'components/DebouncedTextField'
import { FormattedMessage, useIntl } from 'react-intl'
import { PINTEREST_DESCRIPTION_MAX_LENGTH, PINTEREST_TITLE_MAX_LENGTH } from 'shared/constants'

interface PinterestPostAttributesProps {
  pin: {
    title: string
    description: string
    destinationUrl: string
  }
  onTitleChange: (title: string) => void
  onDescriptionChange: (description: string) => void
  onDestinationUrlChange: (url: string) => void
  applyPinTitleToAll: () => void
  applyPinUrlToAll: () => void
}

export function PinterestPostAttributes({
  pin,
  onTitleChange: onPinTitleChange,
  onDescriptionChange: onPinDescriptionChange,
  onDestinationUrlChange: onPinLinkChange,
  applyPinTitleToAll,
  applyPinUrlToAll
}: PinterestPostAttributesProps) {
  const intl = useIntl()

  return (
    <div className={styles.pin}>
      <div className={styles['pin-input-row']}>
        <DebouncedTextField
          value={pin.title}
          multiline
          placeholder={intl.formatMessage({ id: 'composer.labels.pinterest-title-placeholder' })}
          classes={{ root: styles['title-box'] }}
          FormHelperTextProps={{ className: styles.helper }}
          maxLength={PINTEREST_TITLE_MAX_LENGTH}
          onTextChange={onPinTitleChange}
        />
        <span role="button" className={styles['txt-btn']} onClick={applyPinTitleToAll}>
          <FormattedMessage id="actions.copy-to-all" />
        </span>
      </div>
      <div className={styles['pin-input-row']}>
        <DebouncedTextField
          value={pin.description}
          multiline
          maxLength={PINTEREST_DESCRIPTION_MAX_LENGTH}
          placeholder={intl.formatMessage({ id: 'composer.labels.pinterest-text-placeholder' })}
          className={styles['description-box']}
          InputProps={{
            classes: {
              root: styles['description-input']
            }
          }}
          FormHelperTextProps={{ className: styles.helper }}
          onTextChange={onPinDescriptionChange}
        />
        <span role="button" className={styles['txt-btn']}></span>
      </div>
      <div className={styles['pin-input-row']}>
        <DebouncedTextField
          value={pin.destinationUrl}
          placeholder={intl.formatMessage({ id: 'composer.labels.pinterest-link-placeholder' })}
          className={styles['link-box']}
          FormHelperTextProps={{ className: styles.helper }}
          InputProps={{
            classes: {
              root: styles['link-input']
            }
          }}
          onTextChange={onPinLinkChange}
        />
        <span role="button" className={styles['txt-btn']} onClick={applyPinUrlToAll}>
          <FormattedMessage id="actions.copy-to-all" />
        </span>
      </div>
    </div>
  )
}
